module.exports = __webpack_public_path__ + "images/corners/Philo.4596c103337ee2794c6e93fe5cdf6491.jpg";